import React from 'react';
import { Link } from 'react-router-dom';

import Ab2 from '../../images/about/img-3.jpg'
import Ab3 from '../../images/about/img-4.jpg'

const aboutS2 = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="wpo-about-section-s2 section-padding">
            <div className="container">
                <div className="wpo-about-section-wrapper">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-content">
                                <div className="wpo-about-content-top">
                                    <h2>About Us</h2>
                                    <p>LLC "TEZROH" -is a transport company that has been providing quality transportation services for over 5 years. We offer quality cargo delivery at the best prices in the CIS and Baltic countries.</p>
                                </div>
                                <div className="wpo-about-check-wrap">
                                    <div className="wpo-about-check-item">
                                        <p>At the same time, the geography of our work is steadily expanding and we are happy to work for you.</p>
                                    </div>
                                    <div className="wpo-about-check-item">
                                        <p>Each client of the company is provided with an individual approach, taking into account the optimization of costs and offering the best method of cargo delivery.</p>
                                    </div>
                                    <div className="wpo-about-check-item">
                                        <p> The company's door-to-door service speaks for itself, including the full range of services provided by us.</p>
                                    </div>
                                    <div className="wpo-about-check-item">
                                        <p>The development of the organization occurs due to profit, without bank mortgages and loans. We fulfill our obligations in good faith to clients as well as to our contractors, thanks to whom a trusting cooperation has been established for more than one year</p>
                                    </div>
                                </div>
                                <Link onClick={ClickHandler} to="/service" className="theme-btn-s2">All services</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-img ">
                                <div className="wpo-about-img-left">
                                    <img src={Ab2} alt="" />
                                </div>
                                <div className="about-img-inner">
                                    <img src={Ab3} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default aboutS2;
